module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('h1', [_vm._v("你可以缩放浏览器试试")]), _vm._v(" "), _c('tree-grid', {
    attrs: {
      "items": _vm.data,
      "columns": _vm.columns
    },
    on: {
      "on-row-click": _vm.rowClick,
      "on-selection-change": _vm.selectionClick,
      "on-sort-change": _vm.sortClick
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-010b5bf9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 44
// module chunks = 1